import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

// Layout wrapper
import AppLayout from '../layout/AppLayout/AppLayout';

// Page components
import HomePage from '../pages/Home/HomePage';
import BlogPage from '../pages/blog/Blog';
import CategoryPage from '../pages/Category/Category';
import BlogDetailsPage from '../pages/BlogDetails/BlogDetailsPage';
import ContactPage from '../pages/Contact/ContactPage';
import AboutPage from '../pages/about/AboutPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicy/PrivacyPolicyPage';
import TermsConditionsPage from '../pages/TermsConditions/TermsConditionsPage';
import NotFound from '../pages/NotFound/NotFound';

// Contexts
import { SearchProvider } from '../contexts/SearchContext';

// Scrolls to the top of the page on every route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const AppRoutes: React.FC = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <SearchProvider>
        <Routes>
          {/* Layout wrapping all main content pages */}
          <Route element={<AppLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/recipe-category" element={<CategoryPage />} />
            <Route path="/recipe" element={<BlogPage />} />
            <Route path="/blog-details/:slug" element={<BlogDetailsPage />} />
            <Route path="/blog-details" element={<BlogDetailsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-and-conditions" element={<TermsConditionsPage />} />
            {/* 404 Fallback page */}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </SearchProvider>
    </BrowserRouter>
  );
};
